import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
// https://github.com/bl00mber/react-phone-input-2
// https://bl00mber.github.io/react-phone-input-2.html

var CustomPhoneInput = function CustomPhoneInput(_ref) {
  var country = _ref.country,
      value = _ref.value,
      onlyCountries = _ref.onlyCountries,
      preferredCountries = _ref.preferredCountries,
      excludeCountries = _ref.excludeCountries,
      placeholder = _ref.placeholder,
      inputProps = _ref.inputProps,
      autoFormat = _ref.autoFormat,
      disabled = _ref.disabled,
      disableDropdown = _ref.disableDropdown,
      disableCountryCode = _ref.disableCountryCode,
      enableAreaCodes = _ref.enableAreaCodes,
      enableTerritories = _ref.enableTerritories,
      enableLongNumbers = _ref.enableLongNumbers,
      countryCodeEditable = _ref.countryCodeEditable,
      enableSearch = _ref.enableSearch,
      disableSearchIcon = _ref.disableSearchIcon,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      required = _ref.required;
  return React.createElement(PhoneInput, {
    country: country,
    value: value,
    onlyCountries: onlyCountries,
    preferredCountries: preferredCountries,
    excludeCountries: excludeCountries,
    placeholder: placeholder,
    inputProps: inputProps,
    autoFormat: autoFormat,
    disabled: disabled,
    disableDropdown: disableDropdown,
    disableCountryCode: disableCountryCode,
    enableAreaCodes: enableAreaCodes,
    enableTerritories: enableTerritories,
    enableLongNumbers: enableLongNumbers,
    countryCodeEditable: countryCodeEditable,
    enableSearch: enableSearch,
    disableSearchIcon: disableSearchIcon,
    onChange: onChange,
    onBlur: onBlur,
    required: required
  });
};

export default CustomPhoneInput;